/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_d37508c0"]'><div :class='["checkbox-group-round-disabled-demo"]'><div :class='["cube-checkbox-group-example"]'><cube-checkbox-group :options="(options)" :inline="(true)" :values="checkedValues" mpxModelEvent="input" @mpxModel='(e)=>__invoke(e, [["__model","checkedValues", "__mpx_event__", ["value"], undefined]])' :class='["inline-checkbox-group"]'></cube-checkbox-group></div><div :class='["view-desc"]'>checked values：{{ checkedValues }}</div></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_d37508c0"}'>
.cube-checkbox-example
  padding 5px 10px
  background-color #fff
.desc
  margin-top 15px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_d37508c0"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_d37508c0"}
  /** script content **/
  require("./round-disabled.mpx.js?isComponent&outputPath=components%2Fround-disabledd37508c0%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./round-disabled.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fround-disabledd37508c0%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_d37508c0"],
    ctorType: "component",
    outputPath: "components/round-disabledd37508c0/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-checkbox-group':getComponent(require("../../../packages/mpx-cube-ui/src/components/checkbox-group/index.mpx?isComponent&outputPath=components%2Findexc8b9c288%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>